export default __webpack_public_path__ + "static/media/raj.e4c4aba5.jpeg";